export default __webpack_public_path__ + "static/media/q2_06.b486050a.png";